/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';

/**
 * 
 * @export
 * @interface ResultHistoryEntryDto
 */
export interface ResultHistoryEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ResultHistoryEntryDto
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultHistoryEntryDto
     */
    enumerationOptionName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResultHistoryEntryDto
     */
    value?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResultHistoryEntryDto
     */
    userId?: number;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof ResultHistoryEntryDto
     */
    user?: HistoryDtoUser | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof ResultHistoryEntryDto
     */
    output?: EvaluationState;
    /**
     * 
     * @type {string}
     * @memberof ResultHistoryEntryDto
     */
    $type?: ResultHistoryEntryDtoTypeEnum;
}


/**
 * @export
 */
export const ResultHistoryEntryDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoResultHistoryEntryDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ResultHistoryEntryDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ResultHistoryEntryDtoTypeEnum = typeof ResultHistoryEntryDtoTypeEnum[keyof typeof ResultHistoryEntryDtoTypeEnum];


/**
 * Check if a given object implements the ResultHistoryEntryDto interface.
 */
export function instanceOfResultHistoryEntryDto(value?: unknown): value is ResultHistoryEntryDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ResultHistoryEntryDtoTypeEnum)[0];
}

export function ResultHistoryEntryDtoFromJSON(json: any): ResultHistoryEntryDto {
    return ResultHistoryEntryDtoFromJSONTyped(json, false);
}

export function ResultHistoryEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultHistoryEntryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
        'enumerationOptionName': !exists(json, 'enumerationOptionName') ? undefined : json['enumerationOptionName'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'user': !exists(json, 'user') ? undefined : HistoryDtoUserFromJSON(json['user']),
        'output': !exists(json, 'output') ? undefined : EvaluationStateFromJSON(json['output']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ResultHistoryEntryDtoToJSON(value?: ResultHistoryEntryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'timestamp': value.timestamp,
        'enumerationOptionName': value.enumerationOptionName,
        'value': value.value,
        'userId': value.userId,
        'user': HistoryDtoUserToJSON(value.user),
        'output': EvaluationStateToJSON(value.output),
        '$type': value.$type,
    });
}

